import React from 'react'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faUpRightFromSquare'
import { CompanyDto } from '../api/company/models/CompanyDto'
import { getLinkedInUrl } from '../utils/companyUtils'

interface Props {
    company: CompanyDto
    classes?: string
}

function CompanyUi({ company, classes }: Props): React.JSX.Element {
    const allClasses = clsx(
        'flex flex-col items-start gap-1 my-0 w-[180px]',
        classes,
    )
    const imageClasses = clsx(
        'object-cover',
        classes?.includes('w-') || classes?.includes('h-')
            ? ''
            : 'w-[50px] h-[50px]',
        classes,
    )

    return (
        <div className={allClasses}>
            {company.logoUrl ? (
                <img
                    src={company.logoUrl}
                    alt={`${company.name}`}
                    className={imageClasses}
                    onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                        e.currentTarget.onerror = null // Prevent infinite loop if fallback image also fails
                        e.currentTarget.src = '/no-company-logo.png'
                    }}
                />
            ) : (
                <img
                    src="/no-company-logo.png"
                    alt={`${company.name}`}
                    className={imageClasses}
                />
            )}
            <div className="flex flex-col justify-start items-start w-full">
                <div>
                    {company.linkedInId ? (
                        <a
                            href={getLinkedInUrl(company.linkedInId)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link-text whitespace-normal"
                        >
                            {company.name}{' '}
                            <FontAwesomeIcon
                                icon={faUpRightFromSquare}
                                className="text-[#0f40c9] w-3"
                            />
                        </a>
                    ) : (
                        <span className="break-words">{company.name}</span>
                    )}
                </div>
            </div>
            <div className="flex gap-2">
                <div className="field-label">Employees:</div>
                <div className="field-label">{company.personCount}</div>
            </div>
        </div>
    )
}

export default CompanyUi
